// https://git.hubteam.com/HubSpotProtected/Merchandise/blob/master/MerchandiseCore/src/main/java/com/hubspot/merchandise/core/ChargeType.java
export const RECURRING = 'RECURRING';
export const NON_RECURRING = 'NON_RECURRING';